export const fetchProductFromHandle = async (handle) => {
  try {
    if (!handle) return null;
    const endpoint = `/json/products/${handle}.json`;
    const response = await fetch(endpoint);
    return await response.json();
  } catch (error) {
    console.error(error.message);
    return null;
  }
};

export const fetchProductsFromHandles = async (handles) => {
  try {
    if (!Array.isArray(handles) || !handles?.length) return [];
    const productPromises = handles.map(fetchProductFromHandle);
    return Promise.all(productPromises);
  } catch (error) {
    console.error(error.message);
    return [];
  }
};
